const isValidFilesize = (file: any, maxSize: number): boolean => {
    const size = file.size / 1024 / 1024;

    const isValid = size <= maxSize;

    return isValid;
};

export { isValidFilesize };
